import { parseHtml } from "@grandvisionhq/lib-utils-html";
const mergeLabels = (labels) => {
  return Object.keys(labels).reduce((merged, key) => {
    const labelGroup = labels[key];
    if (!labelGroup) return merged;
    return {
      ...merged,
      ...Object.entries(labelGroup).reduce(
        (innerLabels, [labelKey, label]) => ({
          ...innerLabels,
          [`${key}.${labelKey}`]: label
        }),
        {}
      )
    };
  }, {});
};
const hasLabel = (labels, key) => !!labels[key];
const isDebugEnabled = function() {
  try {
    return !!localStorage.getItem("gv:debug:intl");
  } catch (error) {
    return false;
  }
}();
const getLabel = (labels, key, optionsConfig = {}) => {
  const { defaultValue, hideLabelKey = false } = optionsConfig;
  if (isDebugEnabled) {
    return `[${key}]`;
  }
  const labelValue = labels[key] || defaultValue;
  if (!labelValue) {
    if (hideLabelKey) {
      return "";
    }
    console.warn(`No translation found for key: [${key}]`);
    return `[${key}]`;
  }
  return labelValue;
};
const getFormattedLabel = (labels, key, optionsConfig = {}, event) => {
  const {
    parseLink: parseLinkEnabled,
    parseHTML,
    labelData,
    openLinksInNewTab,
    ...getLabelOptions
  } = optionsConfig;
  let label = getLabel(labels, key, getLabelOptions);
  if (isDebugEnabled) {
    return label;
  }
  if (labelData) {
    label = replaceVars(label, labelData);
  }
  if (parseLinkEnabled) {
    label = parseLink(label, openLinksInNewTab);
  }
  if (parseHTML || parseLinkEnabled && parseHTML !== false) {
    if (event) {
      label = parseHtml(label, void 0, () => {
        const tealiumEvent = globalThis.dispatchEvent(
          new CustomEvent("gv:onTealiumEvent", {
            detail: {
              ...event,
              id: "Click"
            }
          })
        );
        if (!tealiumEvent) {
          console.error("[Tealium] [HTML] [Link] Error dispatching click event:", event);
        }
      });
    } else {
      label = parseHtml(label);
    }
  }
  return label;
};
const replaceVars = (label, data) => {
  Object.keys(data).forEach((key) => {
    const labelGroup = data[key];
    if (!labelGroup) return;
    label = label.replace(`{${key}}`, labelGroup.toString());
  });
  return label;
};
const parseLink = (label, openInNewTab = false) => {
  const regex = /[\[]{1}([^\]\[]+)[\]]{1}[(]{1}([^()"]+)("(.+)")?[)]{1}/g;
  return label.replace(
    regex,
    openInNewTab ? '<a href="$2" title="$4" target="_blank" rel="noopener">$1</a>' : '<a href="$2" title="$4">$1</a>'
  );
};
export {
  getFormattedLabel,
  getLabel,
  hasLabel,
  mergeLabels,
  parseLink,
  replaceVars
};
//# sourceMappingURL=helpers.js.map
